export default {
    title: 'Status ändern',

    changeStatus: 'Status ändern',
    status: 'Status',

    changeStatusHelpText: 'Sollten bei einer Statusänderung bearbeitbare Statusbenachrichtigungen ausgelöst werden, werden diese sofort verschickt, ohne dass eine Bemerkung gesetzt werden kann.',

    maxStatisticProcessesForChangingStatus: 'Es können maximal {max} Statistikmeldungen gleichzeitig bearbeitet werden.',
    changeStatusNotAvailableForStatisticProcesses: 'Der ausgewählte Status ist für die folgenden Statistikmeldungen nicht verfügbar: {statisticProcesses}.',

    statusChangedSuccessfully: 'Der Status wurde erfolgreich geändert.',
    errorOnChangeStatus: 'Fehler beim Ändern des Status.',
}